import { templateDefinitions, type TemplateKey } from '../../shared/templates';

export type ClientTemplateDefinition = {
  key: TemplateKey;
  name: string;
  description: string;
  badge: string;
  features: string[];
  visual: 'train-image' | 'mosaic-art' | 'orbital-art' | 'race-art' | 'balance-art' | 'basket-art' | 'goal-art' | 'billionaire-art' | 'ufo-art' | 'rally-art' | 'station-art';
};

export const clientTemplateRegistry: ClientTemplateDefinition[] = [
  { key: 'station-run', name: templateDefinitions['station-run'].name,
    description: 'Üç rayda koş, trenlerden kaç, bariyerlerden zıpla; her 100 metrede istasyonda dur ve soruyu bilerek yolculuğuna devam et.',
    badge: 'Yeni · 3B koşu', features: ['5–20 istasyon, 2–4 seçenek', '4 can, altın = puan', 'Kaydırarak zıpla, kay, şerit değiştir'], visual: 'station-art' },
  { key: 'lane-rally', name: templateDefinitions['lane-rally'].name,
    description: 'Gaz pedalına bas, cevap tabelalarını oku ve doğru cevabın şeridine geçerek 3B otoyolda bitişe yarış.',
    badge: 'Yeni · 3B yarış', features: ['5–20 soru, 2–4 şerit', 'Gaz pedalı ve kaydırma', 'Altın bonusu, elemesiz engeller'], visual: 'rally-art' },
  { key: 'ufo-adventure', name: templateDefinitions['ufo-adventure'].name,
    description: 'UFO’nun rotasını seç, ışıklı geçitlerden süzül ve durmadan değişen uzay manzaralarında bilgini keşfet.',
    badge: 'Yeni · Uzay keşfi', features: ['5–20 soru, 2–4 seçenek', 'Kesintisiz uçuş', 'Öğretmenin seçtiği geçiş modu'], visual: 'ufo-art' },
  {
    key: 'train-adventure',
    name: templateDefinitions['train-adventure'].name,
    description: 'Hareket eden cevap balonlarını doğru vagonlara indir; 1’den 5’e yükselen seviyelerle öğrenmeyi bir yolculuğa dönüştür.',
    badge: 'Yolculuk şablonu',
    features: ['Metin ve görsel soruları', 'Geniş veya dar vagonlar', '3 can ve seri puanı'],
    visual: 'train-image',
  },
  {
    key: 'fiery-route',
    name: templateDefinitions['fiery-route'].name,
    description: "Kıvıl'ı mozaik bahçede yönlendir, Çiselerden kaç ve doğru cevap geçidine ulaş.",
    badge: 'Yeni şablon',
    features: ['1–10 soruluk rota', '2–6 cevap geçidi', 'Analog mobil joystick'],
    visual: 'mosaic-art',
  },
  {
    key: 'orbital-bridge',
    name: templateDefinitions['orbital-bridge'].name,
    description: 'Doğru enerji modülünü seç, eksik köprüyü tamamla ve paletli keşif aracınla yörüngede ilerle.',
    badge: 'Uzay yolculuğu',
    features: ['İki farklı oyun modu', '1–10 soru, 2–5 seçenek', 'İsteğe bağlı soru süresi'],
    visual: 'orbital-art',
  },
  {
    key: 'turbo-duel',
    name: templateDefinitions['turbo-duel'].name,
    description: 'Soruları cevapla, elektrikli GT aracının turbosunu ateşle ve iki rakibini bitişte geride bırak.',
    badge: 'Yarış şablonu',
    features: ['1–10 soru, 2–5 seçenek', '3 araçlı kesintisiz yarış', 'İsteğe bağlı soru süresi'],
    visual: 'race-art',
  },
  {
    key: 'balance-arena',
    name: templateDefinitions['balance-arena'].name,
    description: 'Gökyüzündeki hareketli platformda dengeni koru; doğru cevaplarla merkeze dön ve düşmeden bütün soruları tamamla.',
    badge: 'Denge şablonu',
    features: ['5–25 soru, 2–5 seçenek', 'Tek düşüşte oyun sonu', 'Soru bazlı ayrıntılı rapor'],
    visual: 'balance-art',
  },
  {
    key: 'basket-learning',
    name: templateDefinitions['basket-learning'].name,
    description: 'Gece finalinde soruları cevapla, 3B atışlarını potaya gönder ve seri basketlerle salonu aydınlat.',
    badge: '3B basketbol şablonu',
    features: ['4–20 soru, 2–5 seçenek', 'Metin ve görsel desteği', 'Soru bazlı ayrıntılı rapor'],
    visual: 'basket-art',
  },
  {
    key: 'goal-arena',
    name: templateDefinitions['goal-arena'].name,
    description: 'Soruyu cevapla, topun arkasından kaleye bak ve doğru cevapta kaleciyi geçen gerçekçi bir şutla golü bul.',
    badge: '3B futbol şablonu',
    features: ['4–20 soru, 2–5 seçenek', 'Birinci şahıs 3B stadyum', 'Kaleci, direk ve file tepkileri'],
    visual: 'goal-art',
  },
  {
    key: 'billionaire-quiz',
    name: templateDefinitions['billionaire-quiz'].name,
    description: 'Dört seçenekli sorularla kasanı büyüt, sürpriz kasa kartlarını aç ve milyonluk final basamağına ulaş.',
    badge: 'TV yarışması şablonu',
    features: ['5–20 soru, tam 4 seçenek', 'Otomatik para merdiveni', 'Sürpriz bonus turları'],
    visual: 'billionaire-art',
  },
];

export function clientTemplate(key: TemplateKey): ClientTemplateDefinition {
  return clientTemplateRegistry.find((template) => template.key === key)!;
}
